export default import.meta.ROLLDOWN_FILE_URL_P4DPfwIRieI8P6q8r4JZRw